import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss'
import Spinner from '../Spinner';

function ImageLoader({refObject, className, showLoader=false}) {
    const {t} = useTranslation()
    return (
    <div ref={refObject} className={`${styles.loadingImage} ${className}`}><span>{t('global.loadingImage')}</span>{showLoader && <Spinner/>}</div>
    );
}

export default ImageLoader;